import {
  advancedFormControl,
  FormControlTypeEnum,
} from '@magieno/common';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { ErrorMessageBuilder } from '../../../../../builders/error-message.builder';
import { v4 as uuid } from 'uuid';
import { FieldTypeEnum } from '../../../../../enums/field-type.enum';
import {IsInt, IsNotEmpty, IsString} from "@pristine-ts/class-validator";

@translationBaseKey('corporate-income-tax-connected-corporations-options')
export class CorporateIncomeTaxConnectedCorporationOptions {
  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Nom de la société rattachée',
        en: 'Connected corporation name',
      },
      tooltip: {
        fr: 'Le nom de la société rattachée à la société principale.',
        en: 'The name of the corporation connected to the main company.',
      },
    },
    fieldType: FieldTypeEnum.String,
    type: FormControlTypeEnum.Input,
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  title: string;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Identifiant de la société rattachée',
        en: 'Connected corporation ID',
      },
      tooltip: {
        fr: 'L\'identifiant unique de la société rattachée généré automatiquement.',
        en: 'The unique identifier of the connected corporation automatically generated.',
      },
    },
    fieldType: FieldTypeEnum.String,
    type: FormControlTypeEnum.Input,
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  id: string = uuid();

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'RTDND de la société rattachée',
        en: 'Connected corporation non-eligible dividend refund (RTDND)',
      },
      tooltip: {
        fr: 'Le montant du remboursement des dividendes non admissibles (RTDND) de la société rattachée.',
        en: 'The amount of the non-eligible dividend refund (RTDND) of the connected corporation.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  dividendRefundNonEligible: number;
  //RTDND_rattache: number

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'RTDD de la société rattachée',
        en: 'Connected corporation eligible dividend refund (RTDD)',
      },
      tooltip: {
        fr: 'Le montant du remboursement des dividendes admissibles (RTDD) de la société rattachée.',
        en: 'The amount of the eligible dividend refund (RTDD) of the connected corporation.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  dividendRefundEligible: number;
  //RTDD_rattache: number

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Dividendes ordinaires reçus de sociétés rattachées',
        en: 'Non-eligible dividends received from connected corporations',
      },
      tooltip: {
        fr: 'Le montant des dividendes ordinaires non admissibles reçus de la société rattachée.',
        en: 'The amount of non-eligible dividends received from the connected corporation.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  nonEligibleDividendReceived: number;
  //dividende_ordinaire_rattache: number

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Dividendes déterminés reçus de sociétés rattachées',
        en: 'Eligible dividends received from connected corporations',
      },
      tooltip: {
        fr: 'Le montant des dividendes déterminés admissibles reçus de la société rattachée.',
        en: 'The amount of eligible dividends received from the connected corporation.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  eligibleDividendReceived: number;
  //dividende_déterminé_rattache: number

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Dividende total versé par la société rattachée',
        en: 'Total dividends paid by the connected corporation',
      },
      tooltip: {
        fr: 'Le montant total des dividendes versés par la société rattachée.',
        en: 'The total amount of dividends paid by the connected corporation.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  totalDividendPaid: number;
  //dividende_total_verse: number
}

